import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { checkElementOverflow, isPc, observeScrollToBottom } from "./funcs";

gsap.registerPlugin(ScrollTrigger)

document.querySelectorAll(`.gsap-scrolltrigger,.gsap-scrolltrigger-opa`).forEach((tr) => {
    ScrollTrigger.create({
        trigger: tr,
        start: "top 75%",
        end: "bottom 25%",
        // markers: true,
        onToggle: (self) => {
            if (self.isActive && !self.trigger.classList.contains(`gsap-scrolltrigger-fired`)) {
                self.trigger.classList.add(`gsap-scrolltrigger-fired`)
                setTimeout(() => {
                    self.trigger.classList.add(`gsap-scrolltrigger-ended`)
                }, 1500);
            }
        },
    });
})


const fv = document.querySelector(`.fv`)
const fvCkBb = document.querySelector(`.fv__bgCk.type-bb`)
const fvCkUmab = document.querySelector(`.fv__bgCk.type-umab`)
const fvCkUmab2 = document.querySelector(`.fv__bgCk.type-umab.n-1`)
const fvCkBsb = document.querySelector(`.fv__bgCk.type-bsb`)
const fvCkMl = document.querySelector(`.fv__bgCk.type-ml`)
const fvCkUb = document.querySelector(`.fv__bgCk.type-ub`)
const fvCkTc = document.querySelector(`.fv__bgCk.type-tc`);

const fvCksBb = document.querySelectorAll(`.fv__bgCk.type-bb`)
const fvCksUmab = document.querySelectorAll(`.fv__bgCk.type-umab`)
const fvCksBsb = document.querySelectorAll(`.fv__bgCk.type-bsb`)
const fvCksMl = document.querySelectorAll(`.fv__bgCk.type-ml`)
const fvCksUb = document.querySelectorAll(`.fv__bgCk.type-ub`)
const fvCksTc = document.querySelectorAll(`.fv__bgCk.type-tc`);

const fvStore = document.querySelector(`.fv__store`)
const fvStoreCkBb = fvStore.querySelector(`.type-bb`)
const fvStoreCkUmab = fvStore.querySelector(`.type-umab`)
const fvStoreCkBsb = fvStore.querySelector(`.type-bsb`)
const fvStoreCkMl = fvStore.querySelector(`.type-ml`)
const fvStoreCkUb = fvStore.querySelector(`.type-ub`)
const fvStoreCkTc = fvStore.querySelector(`.type-tc`)

//window.shakeCookiesTl = shakeCookiesTl;
//window.shakeCookies = shakeCookies;

const startOffsetSec = 0.4 * 3
const shakeStartOffsetSec = 0.4 * 3
const moveDur = 0.75
const fvStoreTl = gsap.timeline(
    {
        repeat: -1,
        repeatDelay: 0,
    }
)

fvStoreTl.timeScale(1.75)

// const moveCookies = () => {
//     [
//         fvCksBb,
//         fvCksUmab,
//         fvCksBsb,
//         fvCksMl,
//         fvCksUb,
//         fvCksTc,
//     ].forEach((cks, cksIndex) => {
//         cks.forEach((ck, ckIndex) => {
//             const debugCk = cksIndex === 0 && ckIndex === 0
//             const ckInnerBlock = ck.querySelector(`.fv__bgCkInnerBlock`)

//             const moveCkTl = gsap.timeline(
//                 {
//                     onComplete: function () {
//                         const ce = checkElementOverflow(ckInnerBlock, fv)

//                         if (ce.isCompletelyOutside && ce.overflow.bottom && ce.overflow.left) {
//                             setTimeout(() => {
//                                 const ckRect = ck.getBoundingClientRect()
//                                 gsap.set(ck, {
//                                     x: `+=${parseFloat(gsap.getProperty(ck, "x") as string) + innerWidth}px`,
//                                     y: `-=${parseFloat(gsap.getProperty(ck, "y") as string) - innerHeight}px`,
//                                 })
//                                 if (debugCk) {
//                                     console.log([ck.className, parseFloat(gsap.getProperty(ck, "x") as string), parseFloat(gsap.getProperty(ck, "y") as string) );
//                                 }
//                             }, 100);
//                         }

//                         this.kill()
//                     }
//                 }
//             )

//             moveCkTl.to(ck, {
//                 duration: moveDur,
//                 ease: "none",
//                 x: `-=${innerWidth * 0.075}px`,
//             }, 0)

//             moveCkTl.to(ck, {
//                 duration: moveDur * 0.1,
//                 ease: "sine.out",
//                 y: `-=${innerWidth * 0.005 * 0.5}px`,
//             }, 0)

//             moveCkTl.to(ck, {
//                 duration: moveDur * 0.9,
//                 ease: "sine.in",
//                 y: `+=${innerWidth * 0.08 * 0.5}px`,
//             }, moveDur * 0.1)
//         })
//     })
// }

// const moveCookiesInterval = () => {
//     moveCookies()

//     setInterval(moveCookies, (moveDur + 0.4) * 1000)
// }

// moveCookiesInterval()

const moveCookies = () => {

    const tls = [];

    [
        fvCksBb,
        fvCksUmab,
        fvCksBsb,
        fvCksMl,
        fvCksUb,
        fvCksTc,
    ].forEach((cks, cksIndex) => {
        cks.forEach((ck, ckIndex) => {
            const debugCk = cksIndex === 0 && ckIndex === 0
            // const ckInnerBlock = ck.querySelector(`.fv__bgCkInnerBlock`)

            const ckStyle = window.getComputedStyle(ck)
            const ckInfo = {
                top: parseFloat(ckStyle.top),
                left: parseFloat(ckStyle.left),
                w: parseFloat(ckStyle.width),
                h: parseFloat(ckStyle.height),
            }

            const moveInfo = {
                minX: 0,
                minY: ((innerHeight - (ckInfo.top + ckInfo.h)) / ckInfo.h),
                maxX: ((innerWidth - ckInfo.left) / ckInfo.w),
                maxY: ((innerHeight - ckInfo.top) / ckInfo.h),
            }

            console.log(ck, ckInfo, moveInfo);

            const moveCkTl = gsap.timeline(

            )

            tls.push(moveCkTl)

            // moveCkTl.to(ck, {
            //     duration: moveDur,
            //     ease: "none",
            //     x: `-=${innerWidth * 0.075}px`,
            // }, 0)

            // moveCkTl.to(ck, {
            //     duration: moveDur * 0.1,
            //     ease: "sine.out",
            //     y: `-=${innerWidth * 0.005}px`,
            // }, 0)

            // moveCkTl.to(ck, {
            //     duration: moveDur * 0.9,
            //     ease: "sine.in",
            //     y: `+=${innerWidth * 0.08}px`,
            // }, moveDur * 0.1)
        })
    })

    return tls
}

// moveCookies()

const shakeCookies = (startFrame) => {

    const finalStartFrame = startFrame - shakeStartOffsetSec

    const rotateVal = Math.random() > 0.5 ? 5 : -5;

    [
        fvCksBb,
        fvCksUmab,
        fvCksBsb,
        fvCksMl,
        fvCksUb,
        fvCksTc,
    ].forEach((cks) => {
        cks.forEach((ck) => {
            const ckInnerBlock = ck.querySelector(`.fv__bgCkInnerBlock`)

            fvStoreTl.to(ckInnerBlock,
                {
                    duration: 0.0001,
                    rotate: rotateVal,
                },
                finalStartFrame
            )
            fvStoreTl.to(ckInnerBlock, {
                duration: 0.0001,
                rotate: 0,
            }, finalStartFrame + 0.4)

            fvStoreTl.to(ckInnerBlock, {
                duration: 0.0001,
                rotate: rotateVal,
            }, finalStartFrame + 0.4 * 2)

            fvStoreTl.to(ckInnerBlock, {
                duration: 0.0001,
                rotate: 0,
            }, finalStartFrame + 0.4 * 3)
        })
    })
}

const runningCharAppear: { from: gsap.TweenVars, to: gsap.TweenVars } = {
    from: {
        opacity: 0,
        scale: 1.05
    },
    to: {
        duration: 0.4,
        opacity: 1,
        scale: 1
    }
}

{
    //1

    const startFrame = 0 + startOffsetSec
    const endFrame = startFrame + 2

    // fvStoreTl.to(
    //     fvStoreCkUb,
    //     {
    //         x: "0%",
    //         y: "0%",
    //     },
    //     startFrame - shakeStartOffsetSec
    // )

    fvStoreTl.to(
        fvStoreCkUb,
        {
            x: "-30%",
            y: "90%",
        },
        endFrame
    )
}

{
    //2

    const startFrame = 4 + startOffsetSec
    const endFrame = startFrame + 2
    shakeCookies(startFrame)

    fvStoreTl.to(
        fvStoreCkBb,
        {
            x: "0%",
        },
        startFrame - shakeStartOffsetSec
    )

    fvStoreTl.to(
        fvStoreCkBb,
        {
            x: "50%",
        },
        endFrame - shakeStartOffsetSec
    )

    if (fvCkBb) {
        fvStoreTl.to(
            fvCkBb.querySelector(`figure.cookie`),
            {
                duration: 0,
                opacity: 0,
            },
            startFrame
        )

        fvStoreTl.fromTo(
            fvCkBb.querySelector(`figure.running`),
            runningCharAppear.from,
            runningCharAppear.to,
            startFrame
        )
    }
}

{
    //3

    const startFrame = 8 + startOffsetSec
    const endFrame = startFrame + 2
    shakeCookies(startFrame)

    fvStoreTl.to(
        fvStoreCkMl,
        {
            x: "0%",
            y: "0%",
        },
        startFrame - shakeStartOffsetSec
    )

    fvStoreTl.to(
        fvStoreCkUmab,
        {
            x: "0%",
            y: "0%",
        },
        startFrame - shakeStartOffsetSec
    )

    fvStoreTl.to(
        fvStoreCkMl,
        {
            x: "50%",
            y: "60%",
        },
        endFrame - shakeStartOffsetSec
    )

    fvStoreTl.to(
        fvStoreCkUmab,
        {
            x: "-60%",
            y: "60%",
        },
        endFrame - shakeStartOffsetSec
    )

    if (fvCkBb) {
        fvStoreTl.to(
            fvCkBb.querySelector(`figure.running`),
            {
                duration: 0,
                opacity: 0,
            },
            startFrame
        )

        fvStoreTl.to(
            fvCkBb.querySelector(`figure.bittencookie`),
            {
                duration: 0,
                opacity: 1,
            },
            startFrame
        )

        fvStoreTl.to(
            fvCkUmab.querySelector(`figure.cookie`),
            {
                duration: 0,
                opacity: 0,
            },
            startFrame
        )

        fvStoreTl.fromTo(
            fvCkUmab.querySelector(`figure.running`),
            runningCharAppear.from,
            runningCharAppear.to,
            startFrame
        )

        fvStoreTl.to(
            fvCkBsb.querySelector(`figure.cookie`),
            {
                duration: 0,
                opacity: 0,
            },
            startFrame
        )

        fvStoreTl.fromTo(
            fvCkBsb.querySelector(`figure.running`),
            runningCharAppear.from,
            runningCharAppear.to,
            startFrame
        )
    }
}

{
    //4

    const startFrame = 12 + startOffsetSec
    const endFrame = startFrame + 2
    shakeCookies(startFrame)

    fvStoreTl.to(
        fvStoreCkBsb,
        {
            y: "0%",
        },
        startFrame - shakeStartOffsetSec
    )

    fvStoreTl.to(
        fvStoreCkBsb,
        {
            y: "70%",
        },
        endFrame - shakeStartOffsetSec
    )

    if (fvCkBb) {
        fvStoreTl.to(
            fvCkBb.querySelector(`figure.bittencookie`),
            {
                duration: 0,
                opacity: 0,
            },
            startFrame
        )

        fvStoreTl.to(
            fvCkBb.querySelector(`figure.cookie`),
            {
                duration: 0,
                opacity: 1,
            },
            startFrame
        )

        fvStoreTl.to(
            fvCkUmab.querySelector(`figure.cookie`),
            {
                duration: 0,
                opacity: 1,
            },
            startFrame
        )

        fvStoreTl.to(
            fvCkUmab.querySelector(`figure.running`),
            {
                duration: 0,
                opacity: 0,
            },
            startFrame
        )

        fvStoreTl.to(
            fvCkBsb.querySelector(`figure.cookie`),
            {
                duration: 0,
                opacity: 1,
            },
            startFrame
        )

        fvStoreTl.to(
            fvCkBsb.querySelector(`figure.running`),
            {
                duration: 0,
                opacity: 0,
            },
            startFrame
        )

        fvStoreTl.to(
            fvCkUb.querySelector(`figure.cookie`),
            {
                duration: 0,
                opacity: 0,
            },
            startFrame
        )

        fvStoreTl.fromTo(
            fvCkUb.querySelector(`figure.running`),
            runningCharAppear.from,
            runningCharAppear.to,
            startFrame
        )

        fvStoreTl.to(
            fvCkMl.querySelector(`figure.cookie`),
            {
                duration: 0,
                opacity: 0,
            },
            startFrame
        )

        if (isPc()) {

            fvStoreTl.to(
                fvCkMl.querySelector(`figure.p18`),
                {
                    duration: 0,
                    opacity: 1,
                },
                startFrame
            )

            fvStoreTl.to(
                fvCkTc.querySelector(`figure.cookie`),
                {
                    duration: 0,
                    opacity: 0,
                },
                startFrame
            )

            fvStoreTl.fromTo(
                fvCkTc.querySelector(`figure.running`),
                runningCharAppear.from,
                runningCharAppear.to,
                startFrame
            )
        } else {
            fvStoreTl.fromTo(
                fvCkMl.querySelector(`figure.running`),
                runningCharAppear.from,
                runningCharAppear.to,
                startFrame
            )

            fvStoreTl.to(
                fvCkTc.querySelector(`figure.cookie`),
                {
                    duration: 0,
                    opacity: 0,
                },
                startFrame
            )

            fvStoreTl.to(
                fvCkTc.querySelector(`figure.p18`),
                {
                    duration: 0,
                    opacity: 1,
                },
                startFrame
            )
        }
    }
}

{
    //5

    const startFrame = 16 + startOffsetSec
    const endFrame = startFrame + 2
    const finalEndFrame = endFrame + 2 + startOffsetSec
    shakeCookies(startFrame)
    shakeCookies(finalEndFrame)


    fvStoreTl.to(
        fvStoreCkTc,
        {
            x: "0%",
        },
        startFrame - shakeStartOffsetSec
    )

    fvStoreTl.to(
        fvStoreCkTc,
        {
            x: "40%",
        },
        endFrame
    )

    //最初のフレームに戻す

    fvStoreTl.to(
        fvStoreCkUb,
        {
            x: "0%",
            y: "0%",
            onComplete: () => {
                fvStoreTl.play(startOffsetSec)
            }
        },
        finalEndFrame
    )

    if (fvCkBb) {
        fvStoreTl.to(
            fvCkBb.querySelector(`figure.cookie`),
            {
                duration: 0,
                opacity: 0,
            },
            startFrame
        )

        fvStoreTl.to(
            fvCkBb.querySelector(`figure.p9`),
            {
                duration: 0,
                opacity: 1,
            },
            startFrame
        )

        fvStoreTl.to(
            fvCkUb.querySelector(`figure.cookie`),
            {
                duration: 0,
                opacity: 1,
            },
            startFrame
        )

        fvStoreTl.to(
            fvCkUb.querySelector(`figure.running`),
            {
                duration: 0,
                opacity: 0,
            },
            startFrame
        )

        if (isPc()) {
            fvStoreTl.to(
                fvCkMl.querySelector(`figure.p18`),
                {
                    duration: 0,
                    opacity: 0,
                },
                startFrame
            )

            fvStoreTl.fromTo(
                fvCkMl.querySelector(`figure.running`),
                runningCharAppear.from,
                runningCharAppear.to,
                startFrame
            )

            fvStoreTl.to(
                fvCkTc.querySelector(`figure.cookie`),
                {
                    duration: 0,
                    opacity: 1,
                },
                startFrame
            )

            fvStoreTl.to(
                fvCkTc.querySelector(`figure.running`),
                {
                    duration: 0,
                    opacity: 0,
                },
                startFrame
            )
        } else {
            fvStoreTl.to(
                fvCkMl.querySelector(`figure.running`),
                {
                    duration: 0,
                    opacity: 0,
                },
                startFrame
            )

            fvStoreTl.to(
                fvCkMl.querySelector(`figure.cookie`),
                {
                    duration: 0,
                    opacity: 1,
                },
                startFrame
            )

            fvStoreTl.to(
                fvCkTc.querySelector(`figure.running`),
                {
                    duration: 0,
                    opacity: 1,
                },
                startFrame
            )

            fvStoreTl.to(
                fvCkTc.querySelector(`figure.p18`),
                {
                    duration: 0,
                    opacity: 0,
                },
                startFrame
            )
        }
        //最初のフレームに戻す
        fvStoreTl.to(
            fvCkBb.querySelector(`figure.cookie`),
            {
                duration: 0,
                opacity: 1,
            },
            finalEndFrame
        )

        fvStoreTl.to(
            fvCkBb.querySelector(`figure.p9`),
            {
                duration: 0,
                opacity: 0,
            },
            finalEndFrame
        )

        if (isPc()) {
            fvStoreTl.to(
                fvCkMl.querySelector(`figure.cookie`),
                {
                    duration: 0,
                    opacity: 1,
                },
                finalEndFrame
            )

            fvStoreTl.to(
                fvCkMl.querySelector(`figure.running`),
                {
                    duration: 0,
                    opacity: 0,
                },
                finalEndFrame
            )
        }

        fvStoreTl.to(
            fvCkTc.querySelector(`figure.cookie`),
            {
                duration: 0,
                opacity: 1,
            },
            finalEndFrame
        )

        fvStoreTl.to(
            fvCkTc.querySelector(`figure.running`),
            {
                duration: 0,
                opacity: 0,
            },
            finalEndFrame
        )
    }
}

const nekoLeftRightElms = document.querySelector(".story__innerBlock").querySelectorAll(`.neko-napori`)

nekoLeftRightElms.forEach((nekoLeftRightElm) => {
    const tl = gsap.timeline(
        {
            repeat: -1,
            repeatDelay: Math.random() * 4 + 3,
            // yoyo: true,
            delay: Math.random() * 4
        }
    )

    tl.fromTo(
        nekoLeftRightElm,
        { x: 10 },
        {
            duration: 0.7,
            x: -10,
            ease: "back.out(4)",
        },
    )
    tl.to(
        nekoLeftRightElm,
        {
            duration: 2,
            x: 10,
            ease: "back.out(1.5)",
        },
    )
})

const aboutImgNekoUme = document.querySelector(".about__innerAllUme figure")
const aboutImgNekoLatte = document.querySelector(".about__innerAllLatte figure")

const aboutImgNekoUmeTl = gsap.timeline(
    {
        repeat: -1,
        repeatDelay: 0.2,
        // yoyo: true,
        delay: Math.random() * 4
    }
)

aboutImgNekoUmeTl.fromTo(
    aboutImgNekoUme,
    { x: `-70%` },
    {
        duration: 0.7,
        x: `0%`,
        ease: "back.out(2)",
    },
)
aboutImgNekoUmeTl.to(
    aboutImgNekoUme,
    {
        duration: 2,
        delay: 1,
        x: `-70%`,
        ease: "back.out(1.5)",
    },
)

const aboutImgNekoLatteTl = gsap.timeline(
    {
        repeat: -1,
        repeatDelay: 0.2,
        // yoyo: true,
        delay: Math.random() * 4
    }
)

aboutImgNekoLatteTl.fromTo(
    aboutImgNekoLatte,
    { x: `60%` },
    {
        duration: 0.7,
        x: `0%`,
        ease: "back.out(2)",
    },
)
aboutImgNekoLatteTl.to(
    aboutImgNekoLatte,
    {
        duration: 2,
        delay: 1,
        x: `60%`,
        ease: "back.out(1.5)",
    },
)

const brand = document.querySelector(`.about__brand`)
const cookies = document.querySelectorAll(`.about__brand .cookie`)

cookies.forEach((cookie) => {
    const val = cookie.getBoundingClientRect().width * innerWidth > 767 ? 0.25 : 0

    gsap.fromTo(
        cookie,
        {
            y: -val,
        },
        {
            scrollTrigger: {
                trigger: brand,
                scrub: Math.random() + 0.5,
                // markers: true,
                // pin: true,
                start: "top center",
                end: "bottom center",
            },
            y: val,
        }
    )
})

const aboutShape = document.querySelector(`.about__shape`)
const aboutShapeBanyana = aboutShape.querySelector(`.about__shapeAnimeBanyanaInner`)
const aboutShapeBanyanaTail = aboutShape.querySelector(`.char-banyana-tail`)
const aboutShapeCk = aboutShape.querySelector(`.cookie`)
let aboutShapeOncePlayed = false

const aboutShapeTl = gsap.timeline({ paused: true, repeat: 0, repeatDelay: 0.25 })
aboutShapeTl.seek(0)

window.aboutShapeTl = aboutShapeTl

aboutShapeTl.from(aboutShapeBanyana, {
    y: `20.490367775831874%`,
}, 0)

aboutShapeTl.from(aboutShapeBanyanaTail, {
    rotate: -5,
}, 0)

aboutShapeTl.from(aboutShapeCk, {
    scale: 1.05,
    opacity: 0,
}, 1.5)

aboutShapeTl.from(aboutShapeCk, {
    rotate: -198.75,
}, 2.5)

aboutShapeTl.to(aboutShapeBanyana, {
    duration: 0.5,
    ease: "back.out(2)",
    y: `-5%`
}, 0)

aboutShapeTl.to(aboutShapeBanyanaTail, {
    duration: 0.75,
    ease: "back.inOut(4)",
    rotate: 10,
    transformOrigin: "40% 75%",
}, 0)

aboutShapeTl.to(aboutShapeBanyanaTail, {
    duration: 0.5,
    ease: "back.out(4)",
    rotate: 0,
    transformOrigin: "40% 75%",
}, 0.75)

aboutShapeTl.to(aboutShapeBanyana, {
    duration: 0.4,
    ease: "none",
    // ease: "circ.out",
    opacity: 0,
}, 1.5)

aboutShapeTl.to(aboutShapeCk, {
    duration: 0.4,
    ease: "circ.inOut",
    // ease: "back.out(2)",
    opacity: 1,
    scale: 1,
}, 1.5)

aboutShapeTl.to(aboutShapeCk, {
    duration: 1,
    ease: "back.out(1)",
    rotate: 0,
}, 2.5)

gsap.to(
    aboutShape,
    {
        scrollTrigger: {
            trigger: aboutShape,
            start: "center center",
            end: "center center",
            toggleActions: "play none none none",
            onEnter: () => {
                if (!aboutShapeOncePlayed) {
                    aboutShapeTl.play(0)
                    aboutShapeOncePlayed = true
                }
            }
        },
    },
)

const qlyNekoGoma = document.querySelector(".qly__innerPointsPointCntCircle figure.goma")
const qlyNekoMatcha = document.querySelector(".qly__innerPointsPointCntCircle figure.matcha")
const qlyNekoGomaSp = document.querySelector(".qly__innerPointsPoint>figure.goma")
const qlyNekoMatchaSp = document.querySelector(".qly__innerPointsPoint>figure.matcha")

const qlyNekoGomaTl = gsap.timeline(
    {
        repeat: -1,
        repeatDelay: Math.random() * 2 + 3,
        // yoyo: true,
        delay: Math.random() * 4
    }
)

qlyNekoGomaTl.fromTo(
    qlyNekoGoma,
    {
        rotate: 51.67,
    },
    {
        duration: 0.6,
        rotate: 51.67 + (15),
        ease: "sine.inOut",
    },
)
qlyNekoGomaTl.to(
    qlyNekoGoma,
    {
        duration: 0.6,
        rotate: 51.67 + (-15),
        ease: "sine.inOut",
    },
)

qlyNekoGomaTl.to(
    qlyNekoGoma,
    {
        duration: 0.45,
        rotate: 51.67 + (0),
        ease: "sine.inOut",
    },
)

const qlyNekosMatchaTl = gsap.timeline(
    {
        repeat: -1,
        repeatDelay: Math.random() * 2 + 3,
        // yoyo: true,
        delay: Math.random() * 4
    }
)

qlyNekosMatchaTl.fromTo(
    qlyNekoMatcha,
    {
        x: `-50%`,
        y: `90%`,
    },
    {
        duration: 0.7,
        x: `0%`,
        y: `0%`,
        ease: "back.out(1.5)",
    },
)
qlyNekosMatchaTl.to(
    qlyNekoMatcha,
    {
        duration: 2,
        delay: 2,
        x: `-50%`,
        y: `90%`,
        ease: "back.out(1.5)",
    },
)

const qlyNekosGomaSpTl = gsap.timeline(
    {
        repeat: -1,
        repeatDelay: Math.random() * 2 + 3,
        // yoyo: true,
        delay: Math.random() * 4
    }
)

qlyNekosGomaSpTl.fromTo(
    qlyNekoGomaSp,
    {
        rotate: 13.28,
    },
    {
        duration: 0.6,
        rotate: 13.28 + (15),
        ease: "sine.inOut",
    },
)
qlyNekosGomaSpTl.to(
    qlyNekoGomaSp,
    {
        duration: 0.6,
        rotate: 13.28 + (-15),
        ease: "sine.inOut",
    },
)

qlyNekosGomaSpTl.to(
    qlyNekoGomaSp,
    {
        duration: 0.45,
        rotate: 13.28 + (0),
        ease: "sine.inOut",
    },
)

const qlyNekosMatchaSpTl = gsap.timeline(
    {
        repeat: -1,
        repeatDelay: 0.2,
        // yoyo: true,
        delay: Math.random() * 4
    }
)

qlyNekosMatchaSpTl.fromTo(
    qlyNekoMatchaSp,
    {
        y: `80%`,
    },
    {
        duration: 0.7,
        y: `0%`,
        ease: "back.out(1.5)",
    },
)
qlyNekosMatchaSpTl.to(
    qlyNekoMatchaSp,
    {
        duration: 2,
        delay: 2,
        y: `80%`,
        ease: "back.out(1.5)",
    },
)

const chunkleTxts = document.querySelectorAll(`.chunkle__bigInnerImgC svg.txt`)

chunkleTxts.forEach((chunkleTxt) => {
    const lineTl = gsap.timeline({ paused: true })
    gsap.fromTo(
        chunkleTxt.querySelectorAll(`g.txts path`),
        {
            opacity: 0,
        },
        {
            duration: 0.25,
            scrollTrigger: {
                trigger: chunkleTxt.closest(`.chunkle__bigInnerImg`),
                start: "center center",
                end: "center center",
                toggleActions: "play none none none",
            },
            opacity: 1,
            stagger: 0.04,
            onComplete: () => {
                lineTl.play(0)
            }
        }
    )

    lineTl.fromTo(
        chunkleTxt.querySelectorAll(`g.lines path`),
        {
            opacity: 0,
        },
        {
            duration: 0.3,
            opacity: 1,
        },
        0
    )
})

const modalChars = document.querySelectorAll(`.Modal.type-char .swiper-slide`)

modalChars.forEach((char) => {
    const imgTl = gsap.timeline({ paused: false, repeat: -1 })
    const imgs = char.querySelectorAll(`.left__imgs figure`)

    imgs.forEach((img) => {
        imgTl.to(img, {
            duration: 4,
            onStart: () => {
                img.classList.add("is-on")
            },
            onComplete: () => {
                imgs.forEach((img2) => {
                    img2.classList.remove("is-on")
                })
            },
        })
    })
})

const footerChars = document.querySelectorAll(`.footer__chars figure`)
let haveBanyanasBeenUp = false

gsap.set(
    footerChars,
    { y: "60%" },
)

const banyanasUp = (

) => {
    if (!haveBanyanasBeenUp) {
        // console.log(`${scrollY}`);
        haveBanyanasBeenUp = true
        gsap.to(
            footerChars,
            {
                y: 0,
                stagger: 0.08,
            }
        )
    }
}

ScrollTrigger.create({
    trigger: document.querySelector(`.footer`),
    start: "top center",
    end: "top center",
    onToggle: (self) => {
        if (self.isActive) {
            banyanasUp()
        }
    },
});

observeScrollToBottom(banyanasUp, 50)